import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakePrecosSpreadsRelativosTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": "N/A",
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "IDRiskFree": 0,
            "IDCurvaRating": 0,
            "DU": 0,
            "FatorTIR": 0,
            "TaxaTIR": 0,
            "FatorRiskFree": 0,
            "TaxaRiskFree": 0,
            "FatorCurvaRating": 0,
            "TaxaCurvaRating": 0,
            "FatorSpreadRelativo": 0,
            "SpreadRelativo": 0,
            "FatorSpreadCurvaRating": 0,
            "SpreadCurvaRating": 0,
            "FatorSpreadCredito": 0,
            "SpreadCredito": 0,
            "LogErro": "N/A",
        }

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, CETIP, DataReferencia, IDRiskFree, IDCurvaRating, DU, FatorTIR, TaxaTIR,
            FatorRiskFree, TaxaRiskFree, FatorCurvaRating, TaxaCurvaRating, FatorSpreadRelativo,
            SpreadRelativo, FatorSpreadCurvaRating, SpreadCurvaRating,
            FatorSpreadCredito, SpreadCredito, LogErro
        } = newRow

        const body = {
            "CETIP": CETIP,
            "DataReferencia": DataReferencia,
            "IDRiskFree": IDRiskFree,
            "IDCurvaRating": IDCurvaRating,
            "DU": DU,
            "FatorTIR": FatorTIR,
            "TaxaTIR": TaxaTIR,
            "FatorRiskFree": FatorRiskFree,
            "TaxaRiskFree": TaxaRiskFree,
            "FatorCurvaRating": FatorCurvaRating,
            "TaxaCurvaRating": TaxaCurvaRating,
            "FatorSpreadRelativo": FatorSpreadRelativo,
            "SpreadRelativo": SpreadRelativo,
            "FatorSpreadCurvaRating": FatorSpreadCurvaRating,
            "SpreadCurvaRating": SpreadCurvaRating,
            "FatorSpreadCredito": FatorSpreadCredito,
            "SpreadCredito": SpreadCredito,
            "LogErro": LogErro

        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            // type: 'date',
            // valueGetter: ({ value }) => value && dayjs(value).toDate(),
            // valueFormatter: params => dayjs(params.value).format(DATE_FORMAT),
            // valueParser: (newValue) => dayjs(newValue).format(DATE_FORMAT),
            disableColumnMenu: true,
            editable: true,
        },
        {
            field: 'IDRiskFree',
            headerName: 'IDRiskFree',
            flex: 1,
            minWidth: 150,
            maxWidth: 300,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'IDCurvaRating',
            headerName: 'IDCurvaRating',
            flex: 1,
            minWidth: 150,
            maxWidth: 300,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DU',
            headerName: 'DU',
            flex: 1,
            minWidth: 150,
            maxWidth: 300,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorTIR',
            headerName: 'FatorTIR',
            flex: 1,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TaxaTIR',
            headerName: 'TaxaTIR',
            flex: 1,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorRiskFree',
            headerName: 'FatorRiskFree',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TaxaRiskFree',
            headerName: 'TaxaRiskFree',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorCurvaRating',
            headerName: 'FatorCurvaRating',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TaxaCurvaRating',
            headerName: 'TaxaCurvaRating',
            flex: 3,
            minWidth: 200,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorSpreadRelativo',
            headerName: 'FatorSpreadRelativo',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SpreadRelativo',
            headerName: 'SpreadRelativo',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorSpreadCurvaRating',
            headerName: 'FatorSpreadCurvaRating',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SpreadCurvaRating',
            headerName: 'SpreadCurvaRating',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FatorSpreadCredito',
            headerName: 'FatorSpreadCredito',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SpreadCredito',
            headerName: 'SpreadCredito',
            flex: 3,
            minWidth: 200,
            maxWidth: 500,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'LogErro',
            headerName: 'LogErro',
            flex: 1,
            minWidth: 150,
            maxWidth: 300,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
          <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            createRow={createRow}
            deleteRow={deleteRow}
            updateRow={updateRow}
            filterFunction={onFilter}
            pagination={pagination}
            onChangePage={changePage}
            customFilter={true}
            />
          </div>
        )
  }

ParameterDatalakePrecosSpreadsRelativosTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakePrecosSpreadsRelativosTable